module.exports = __webpack_public_path__ + "img/create-wallet-m-2-en.dfdc4ed9.png";